import React from 'react';

import { Col, Row } from 'reactstrap';
import styled from 'styled-components';
import { prop } from 'styled-tools';

import CardContent from 'components/ModularBlocks/IconCardBlock/CardContent';

import { IconCardBlockI } from 'interfaces/content-stack/modular-blocks/iconCardBlock';

const H2 = styled.h2`
  color: ${prop('theme.colors.black')};
  font-size: 1.625rem;
  font-weight: 700;
  text-transform: uppercase;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 2.25rem;
  }
`;

const StyledRow = styled(Row)`
  margin: 1rem 0;
`;

export interface IconCardBlockProps {
  data: IconCardBlockI;
}

const IconCardBlock: React.FC<IconCardBlockProps> = ({ data }) => {
  if (!data) {
    return null;
  }

  const { card, sectionTitle } = data;
  const cardsCount = card.length;

  return (
    <div>
      {sectionTitle && <H2>{sectionTitle}</H2>}
      <StyledRow>
        {card?.map((cardItem, index) => (
          <Col key={index} sm={12} md={12 / cardsCount}>
            <CardContent data={cardItem} />
          </Col>
        ))}
      </StyledRow>
    </div>
  );
};

export default IconCardBlock;
